module.exports = __webpack_public_path__ + "img/logo_v4.973719d8.png";